module.exports = __webpack_public_path__ + "static/media/documents.6a94f940.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/documents.svg
// module id = 594
// module chunks = 0